import Immutable from 'seamless-immutable';

export function normalizeAllIntentsFromAPI(intents) {
  return Immutable(
    intents.map((intent) => ({
      id: intent.intent_name,
      title: intent.intent_name,
      active: intent.enabled,
      color: { primary: '#134696' },
    }))
  );
}

export function normalizeIntentFromAPI(intent, intentName) {
  return Immutable({
    id: intentName,
    title: intentName,
    variants: intent?.bot_says?.map((variant) => variant.text),
    sentences: intent.user_says,
  });
}

export function normalizeBotSaysToAPI(botSays) {
  return botSays.map((variant) => ({
    text: variant,
  }));
}
